import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal'

interface ModalProps {
    title: string;
    isOpen: boolean;
    setOpenModal: (val:boolean) => void;
    objectURL:string;
    fileExists?: boolean;
  }
  
  export const ObjectModal: React.FC<ModalProps> = (props) => {
      
    console.log("objectURL",props.objectURL);
    return <Modal show={props.isOpen} onHide={()=>props.setOpenModal(false)}  size="xl" >
                <Modal.Header> 
                    <Modal.Title><h5 className="mx-auto">{props.title}</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body className='text-center pb-3 px-0' style={{ height: '90vh', maxHeight: '1000px', overflowY: 'auto'}} >
                {props.objectURL ? (
                    props.fileExists !== false ? (
                        <iframe 
                            src={props.objectURL} 
                            width="100%" 
                            height="800px" 
                            title="pdf-viewer"
                            onError={() => console.error('PDF loading error:', props.objectURL)}
                        ></iframe>
                    ) : (
                        <div className="d-flex align-items-center justify-content-center" style={{height: '800px'}}>
                            <div className="text-muted">
                                <div className="mb-3">
                                    <i className="fas fa-file-pdf fa-4x text-secondary mb-3"></i>
                                </div>
                                <h5>成果報告檔案不存在</h5>
                                <p className="text-secondary">預期路徑: {props.objectURL}</p>
                                <p className="text-info">請確認檔案是否已上傳或聯繫管理員</p>
                            </div>
                        </div>
                    )
                ) : (
                    <div className="d-flex align-items-center justify-content-center" style={{height: '800px'}}>
                        <div className="text-muted">
                            <div className="spinner-border text-primary mb-3" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p>載入中...</p>
                        </div>
                    </div>
                )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary m-0" onClick={()=>props.setOpenModal(false)}>關閉</button>
                </Modal.Footer>
            </Modal>

  };